import { AnchorHTMLAttributes } from "react";

export const CustomBr = () => <br style={{ marginBottom: '.2em' }} />;

export const CustomLink = ({ children, href, ...props }: AnchorHTMLAttributes<HTMLAnchorElement>) => (
    <a
        href={href}
        {...props}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={typeof children === 'string' ? children : 'External link'}
    >
        {children}
    </a>
);
